<template>
  <in-viewport>
    <div class="photo-section">
      <base-layout hide-sidebar>
        <div slot="content">
          <img :src="photo" alt="" class="photo-section__img">
        </div>
      </base-layout>
    </div>
  </in-viewport>
</template>

<script>
import BaseLayout from '@/components/BaseLayout'

export default {
  components: {
    BaseLayout
  },
  props: {
    photo: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .photo-section {
    &__img {
      @include responsive-img;
      @include vertical-space((top: 1, bottom: 2));
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Team/PhotoSection.vue